// zhaoqing 2019-9-17

'use strict';
angular
    .module('createdBrokeNewsAccountModule', ['tManageMentServiceModule'])
    .controller('createdBrokeNewsAccountCtrl', [
        '$scope',
        '$modalInstance',
        '$q',
        'trsHttpService',
        'item',
        'modalDialog',
        '$validation',
        function(
            $scope,
            $modalInstance,
            $q,
            trsHttpService,
            item,
            modalDialog,
            $validation
        ) {
            initStatus();
            initData();
            var _this = this;
            /** [initStatus description]初始化状态 */
            function initStatus() {
                $scope.status = {
                    serviceTitlt: '新建',
                    detail: false
                };
                $scope.data = {
                    accountName: '',
                    accountNum: '',
                    isFocus: 0,
                    description: '',
                    accountId: ''
                };
            }
            /** [initData description] 初始化数据 */
            function initData() {
                if (!item.item) {
                    $scope.status.serviceTitlt = '新建';
                } else {
                    $scope.data = $.extend({}, item.item);
                    if (item.isDetail) {
                        $scope.status.serviceTitlt = '详情';
                        $scope.status.detail = true;
                    } else {
                        $scope.status.serviceTitlt = '编辑';
                    }
                }
            }
            /** [funciton description]确定按钮执行的操作 */
            $scope.confirm = function() {
                console.log($scope.data);
                $validation
                    .validate($scope.brokeNewsCreate)
                    .success(function() {
                        if (item.item === undefined) {
                            _this.createHandler();
                        } else {
                            _this.editHandler();
                        }
                    })
                    .error(function() {
                        modalDialog.alertType(
                            '请检查填写项!',
                            '',
                            'warning',
                            false
                        );
                    });
            };
            /** [cancel description] 取消操作 */
            /** [cancelb description]直接取消 */
            $scope.cancelb = $scope.cancel = function() {
                $modalInstance.dismiss();
            };

            // 新增 修改
            [['createHandler', '新建'], ['editHandler', '修改']].forEach(
                function(v) {
                    this[v[0]] = function() {
                        $scope.loadingPromise = trsHttpService
                            .httpServer(
                                '/api/tenantcenter/scoopaccount/saveScoopAccount',
                                $scope.data,
                                'post',
                                '',
                                { token: item.token }
                            )
                            .then(function(data) {
                                console.log(data);
                                if (data.code === '200') {
                                    modalDialog.alertType(
                                        v[1] + '成功!',
                                        '',
                                        'success',
                                        false
                                    );
                                    $modalInstance.close('success');
                                } else {
                                    modalDialog.alertType(
                                        data.msg || v[1] + '失败请再次尝试!',
                                        '',
                                        'error',
                                        'confirm'
                                    );
                                }
                            });
                    };
                }.bind(this)
            );
        }
    ]);
